import React, { Component } from 'react'
import Alert from 'react-bootstrap/Alert';
import "./style.css";
import Service from "src/api/Service";
import Cockpit from './Cockpit'
import Filter from './Filter';
import PythonService from "src/api/PythonService";
import logo from 'src/assets/images/loading_gray.gif';
import TableLoader from 'src/TableLoader';
import forward from 'src/assets/icons/forward.svg'
import backwards from 'src/assets/icons/backwards.svg'
export class Dashboard extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
     isFetching: true,
     isChecked:false,
     isFilterFetching:false,
     carousel :[],
     alert:[],
     filter_visiable:true,
     showAlert:false,
     showFilter:false,
     scenario:[],
     position:"0px",
     form:[],
     filterForm:[],
     filterData:[],
     countFilter:0,
     palette : null,
     refreshFilterField:true,
    }
    this.collapseAlert = this.collapseAlert.bind(this);
    this.collapseFilter = this.collapseFilter.bind(this);
    this.setShow = this.setShow.bind(this);
    this.FilterFnc = this.FilterFnc.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
   }

   async getDashboardData(){
    await PythonService.get(
      "filters/"+this.props.client_id+"/"
      +this.props.user_id+"/"
      +this.props.module_id+"/"
      +this.props.scenario_id,
      (status,data)=>{

         this.setState({
             filterForm:data,
             filter_visiable:data['filters'],

         });
         
        var data={
          'client-id':this.props.client_id,
          'module-id':this.props.module_id,
          'scenario-id':this.props.scenario_id,
          'user-id':this.props.user_id,
          'selected-product-level':data['product-level']['default-value'],
          'selected-location-from-level':data['location-from-level']['default-value'],
          'selected-period-type': data['period-bucket-list']['default-value'],
          'selected-location-from-list':data['location-from-list']['default-value'],
          'selected-product-list':data['product-list']['default-value'],
          'selected-period-list':data['period-list']['default-value'],
          'selected-location-attribute-list':data['location-attribute']['default-value'],
          'selected-product-attribute-list':data['product-attribute']['default-value'],
          'filter':false
        }
         PythonService.post("kpi-data",data,(status,data)=>{
          if(status==200){
            this.setState({
              filterData:data,               
              isFetching:false
            })

          }
        });

      });   
  }


  FilterFnc(e){
   
    PythonService.post("kpi-data",e,(status,data)=>{
      console.log(data,status);
      if(status==200){  
        this.setState({
          filterData:data,   
          refreshFilterField:false,
          isFetching:false,
          isFilterFetching:false
        })

      }else{
        this.setState({
          refreshFilterField:false,
          isFetching:false,
          isFilterFetching:false
        });
       }
    });
  }
  GetColorPalette = async () => {
    const USER = JSON.parse(localStorage.getItem("loggedInUserDetails"))
    const clientId = USER.user.clientId
    const obj = await Service.get("/configuration_manager/tabColorCode/" + clientId, (status, data) => {
      if (status == 200) {
        if (data) {
          return data;
        }
      }
    })
    this.setState({
      palette : obj.value
    })
  }
  getScenarioId(){
    var url= "kpiDashboard/scenario/"+this.props.scenario_id+"/"+this.props.user_id;
    Service.get(url,(status,data)=>{  
      console.log(data);   
      if(status==200){
        this.setState({
        scenario:data,
      })
      }
    });
  }
  componentDidMount(){
  this.getDashboardData();
  this.getScenarioId();
  // this.GetColorPalette();
}
async setShow(obj){

  await Service.post("alertsConfig/changestatus",obj,(status,data)=>{           
  if(status==200){    
    this.getDashboardData();            
     this.setState({});   
  }
 });

}
collapseAlert(){
  this.setState({
    showAlert: !this.state.showAlert,
  })
}

collapseFilter(){
  this.setState({
    showFilter: !this.state.showFilter,
  })
}

handleCheckboxChange = () => {
  // setIsChecked(!isChecked);
  this.setState({
    isChecked:!this.state.isChecked
  });
};

async Filter(e){

}



  render(){

    if(this.state.isFetching){
      // return (<><center><TableLoader/></center></>)
      return (<></>)
    }
    if(this.state.isFilterFetching){
      return (<><center><TableLoader/></center></>)
      // return (<><center>...</center></>)
    }
    const textStyle = {
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#333',  // You can specify the color using any valid CSS color value
    };
    return (
      <>

       <div className='row' style={{display:'block'}}>
        <div className='col-lg-12' style={textStyle}>
          <div className='collapse_alerts'>
          <div className="btn-group-vertical cockpit_filter">
              {this.state.filter_visiable ? (
                <button  onClick={this.collapseFilter} className='collapse_btn btn-collapse alertBtn'>
                   {/* <img src={forward} style={{marginLeft:'-10px'}} /> */}
                  <i style={{paddingTop: '0.45rem'}} className={this.state.showFilter?"fa fa-chevron-left":"fa fa-chevron-right"} aria-hidden="true"></i>
                  </button>):(<></>)}

                  {this.state.scenario['is_admin'] =="true"? (
                  <a href={'/config/'+this.props.client_id+'/'+this.props.module_id} className='collapse_btn btn-collapse settingBtn'>
                   <i  style={{paddingTop: '0.4rem'}} className={this.state.showFilter?"fa fa-cog":"fa fa-cog"} aria-hidden="true"></i>
                </a>   
                ):(<></>)}
            </div>
          </div>
        </div>
       </div>
       {/* <div style={{width:'98%', padding:'10px'}} >
      <div className="row">
        <div className="col-lg-6 scenario_name">Dashboard [{this.state.scenario['scenario_name']}]</div>

        <div className='col-lg-6'>
              <div className="form-check component_legend" >
              <span className="bigcheck">
                  <label className="bigcheck">
                      <input type="checkbox" className="bigcheck" onChange={this.handleCheckboxChange}  name="Legend" value="yes"/>
                      <span className="bigcheck-target"></span>
                        Legend
                  </label>
              </span>
            </div>
            </div>
      </div>
      </div>

        */}
       {this.state.filter_visiable ? (
       <div className= '' style={{display:this.state.showFilter?'block':'none'}}>        
          <Filter
           client_id={this.props.client_id}
           refreshFilterField={this.state.refreshFilterField}
           module_id={this.props.module_id}
           scenario_id={this.props.scenario_id}           
           user_id={this.props.user_id}
           filterForm={this.state.filterForm}
           onChange={(e)=>{
            this.setState({
              filterData:e,
              // isFetching:true,
              isFilterFetching:true,
              countFilter:this.state.countFilter+1,
              showFilter: !this.state.showFilter,

            })
            this.FilterFnc(e);
          }}/>
      </div>):(
        <div className="" style={{ display: 'none' }}>
         
        </div>
      )}

      
      <div className='row'>
         
      <div className= {this.state.showAlert?'col-lg-9 col-md-9 col-sm-12':'col-lg-12 col-md-12 col-sm-12'}>       
       <Cockpit 
           client_id={this.props.client_id}
           isChecked={this.state.isChecked}
           module_id={this.props.module_id}
           scenario_id={this.props.scenario_id}
           user_id={this.props.user_id} 
           filter={this.state.filterData} 
           palette={this.state.palette} 
           countFilter={this.state.countFilter} />
      </div>
      
      <div className= 'col-lg-3 col-md-3 col-sm-12' style={{display:this.state.showAlert?'block':'none'}}>
        
        <div className='alert_card overflow-auto'>           
              
              {this.state.alert.map((item, index) => {
              return(
                <Alert className="alert_panel " key={index} variant="light" onClose={() => this.setShow(item)}  dismissible >
                 <p className={'font-weight-bold'} style={{color:item['color']}}> {item['msg']}</p>
                </Alert>
                
              )
              
            })}             
             
            
        </div>
      </div>

    </div>

      </>
    )
  }
}
export default Dashboard
